<div mat-dialog-title>
  <h2>Confirm</h2>
</div>
<div mat-dialog-content>
  <div class="empathy-duplicate-questions-dialog__content">
    <span class="fs__sm fw__400">
      {{ 'Are you sure you want to duplicate ' + (data.questionsCount === 1 ? 'this question?' : 'these ' + data.questionsCount + ' questions?') }}
      @if (data.activeQuestionCode) {
        The copies will be grouped directly below <b>{{ data.activeQuestionCode }}</b
        >.
      }
    </span>

    @if (data.questionsWithConditionsCount > 0 || data.hasTranslations) {
      <div class="empathy-duplicate-questions-dialog__content__alert">
        <div class="empathy-duplicate-questions-dialog__content__alert__header">
          <div class="empathy-duplicate-questions-dialog__content__alert__header-icon">
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
          </div>
          <span class="fs__sm fw__600">Review impacted logic before duplicating</span>
        </div>
        <ul class="empathy-duplicate-questions-dialog__content__alert__info">
          @if (data.questionsWithConditionsCount > 0) {
            <li class="fs__sm fw__400">
              {{
                'Branching logic on ' +
                  (data.questionsCount === 1 ? 'this question' : data.questionsWithConditionsCount + ' of these questions') +
                  " won't be copied. The originals keep their logic."
              }}
            </li>
          }

          @if (data.hasTranslations) {
            <li class="fs__sm fw__400">Duplicated questions need to be translated.</li>
          }
        </ul>
      </div>
    }
  </div>
</div>
<div mat-dialog-actions>
  <eiq-button [text]="'Cancel'" [style]="'stroked'" [color]="'light'" testId="duplicate-questions-dialog-cancel" (clicked)="onCancel()"></eiq-button>
  <eiq-button [text]="'Confirm'" [color]="'primary'" testId="duplicate-questions-dialog-confirm" (clicked)="onConfirm()"></eiq-button>
</div>
